import React from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';
import './style.scss';
var Icon = function Icon(_ref) {
  var _ref$flair = _ref.flair,
    flair = _ref$flair === void 0 ? '' : _ref$flair,
    name = _ref.name,
    className = _ref.className;
  var flairPostFix = flair && flair.length > 0 ? '-' : '';
  var classNames = c('Icon', "Icon-".concat(flair).concat(flairPostFix).concat(name), className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  });
};
Icon.defaultProps = {
  flair: '',
  className: ''
};
Icon.propTypes = {
  name: PropTypes.string.isRequired,
  flair: PropTypes.string,
  className: PropTypes.string
};
export default Icon;